import type { FC } from 'react';

import { SelectUploadStorageFieldWrapper } from '../../ui/forms/field_wrappers/select_upload_storage/select_upload_storage';
import Form from '../../ui/forms/form';

import styles from './uploader_page_destination.module.css';

type Props = {
  value?: string;
  disabled?: boolean;
  canClear?: boolean;
  onChange?: (storageId: string) => void;
};

// Component to select the destination storage for uploads.
// Historically we did not check the ACLs for storages when deciding what storages to allow uploads to.
// We just checked if it had the write setting enabled. This resulted in users being able to upload to all storages
// as long as they had the read ACL.
// This was updated in https://linear.app/iconik/issue/BE-1930/add-new-web-can-upload-legacy-role-and-move-web-can-upload-to-require
// But to avoid changing existing behavior for customers we added a new webCanUploadLegacy role.
// So we now default to the old behavior if the user has the webCanUploadLegacy role enabled.
const UploadDestination: FC<Props> = ({
  value,
  disabled,
  canClear,
  onChange,
}) => {
  return (
    <Form<{ storage: string }>
      className={styles.field}
      onChange={(data) => {
        if (onChange) {
          onChange(data.storage);
        }
      }}
    >
      <SelectUploadStorageFieldWrapper
        canClear={canClear}
        placeholder="Default storage"
        name="storage"
        value={value}
        disabled={disabled}
        isMulti={false}
      />
    </Form>
  );
};
export default UploadDestination;
